import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { History } from 'lucide-react';
import * as React from 'react';
import { PageHeader } from '@/components/layout/AppShell';
import { TransactionRow } from '@/components/lists';
import { AnimatedNumber, Page, Rise } from '@/components/motion';
import { Card } from '@/components/ui/card';
import { EmptyState, ErrorState, Pager } from '@/components/ui/misc';
import { coinsApi } from '@/lib/api/endpoints';
import { useMe } from '@/lib/auth';
import { ListSkeleton } from './ChecksPage';

const LIMIT = 50;

export function TransactionsPage() {
  const me = useMe();
  const [offset, setOffset] = React.useState(0);
  const q = useQuery({
    queryKey: ['transactions', { offset }],
    queryFn: () => coinsApi.transactions({ limit: LIMIT, offset }),
    placeholderData: keepPreviousData,
  });

  return (
    <Page>
      <PageHeader
        eyebrow="Coins"
        title="Coin history"
        description="Every coin that came in or went out."
        actions={
          <div className="rounded-xl border bg-card px-4 py-2 text-right shadow-soft">
            <p className="text-xs text-muted-foreground">Balance</p>
            <p className="text-xl font-black">
              <AnimatedNumber value={me.coin_balance} />
            </p>
          </div>
        }
      />
      <Rise>
        <Card className="overflow-hidden">
          {q.isPending ? (
            <ListSkeleton />
          ) : q.isError ? (
            <ErrorState error={q.error} onRetry={() => q.refetch()} />
          ) : q.data.length === 0 ? (
            <EmptyState icon={<History />} title="No activity yet" />
          ) : (
            <div className="divide-y">
              {q.data.map((t) => (
                <TransactionRow key={t.id} tx={t} />
              ))}
            </div>
          )}
          <Pager offset={offset} limit={LIMIT} count={q.data?.length ?? 0} onChange={setOffset} loading={q.isFetching} />
        </Card>
      </Rise>
    </Page>
  );
}
